module.exports = __webpack_public_path__ + "static/img/Smartshop.b32d853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Smartshop.png
// module id = +dfH
// module chunks = 0